
import { importSync as i, macroCondition, getGlobalConfig } from '@embroider/macros';
let w = window;
let d = w.define;


d("frontend/abilities/base", function(){ return i("../abilities/base.ts");});
d("frontend/adapters/-json-api", function(){ return i("../adapters/-json-api.js");});
d("frontend/adapters/application", function(){ return i("../adapters/application.ts");});
d("frontend/adapters/family", function(){ return i("../adapters/family.ts");});
d("frontend/adapters/user", function(){ return i("../adapters/user.ts");});
d("frontend/app", function(){ return i("../app.ts");});
d("frontend/changeset/create-changeset", function(){ return i("../changeset/create-changeset.js");});
d("frontend/changeset/extended-changeset", function(){ return i("../changeset/extended-changeset.js");});
d("frontend/changeset/immer-changeset", function(){ return i("../changeset/immer-changeset.js");});
d("frontend/changesets/application", function(){ return i("../changesets/application.ts");});
d("frontend/changesets/base", function(){ return i("../changesets/base.js");});
d("frontend/changesets/contact-form", function(){ return i("../changesets/contact-form.ts");});
d("frontend/changesets/contact", function(){ return i("../changesets/contact.ts");});
d("frontend/changesets/forgot-password", function(){ return i("../changesets/forgot-password.js");});
d("frontend/changesets/intra", function(){ return i("../changesets/intra.ts");});
d("frontend/changesets/login", function(){ return i("../changesets/login.js");});
d("frontend/changesets/newsletter", function(){ return i("../changesets/newsletter.ts");});
d("frontend/changesets/profile", function(){ return i("../changesets/profile.ts");});
d("frontend/changesets/recontact-form", function(){ return i("../changesets/recontact-form.ts");});
d("frontend/changesets/register", function(){ return i("../changesets/register.ts");});
d("frontend/changesets/reset-password", function(){ return i("../changesets/reset-password.js");});
d("frontend/component-managers/glimmer", function(){ return i("../component-managers/glimmer.js");});
d("frontend/config/environment", function(){ return i("../config/environment.js");});
d("frontend/data-adapter", function(){ return i("../data-adapter.js");});
d("frontend/decorators/disable-in-fastboot", function(){ return i("../decorators/disable-in-fastboot.js");});
d("frontend/enums/applicant-kind.enum", function(){ return i("../enums/applicant-kind.enum.js");});
d("frontend/enums/base-action-product-status.enum", function(){ return i("../enums/base-action-product-status.enum.js");});
d("frontend/enums/base-action-product-type.enum", function(){ return i("../enums/base-action-product-type.enum.js");});
d("frontend/enums/education-function", function(){ return i("../enums/education-function.js");});
d("frontend/enums/gender.enum", function(){ return i("../enums/gender.enum.js");});
d("frontend/enums/job-status.enum", function(){ return i("../enums/job-status.enum.js");});
d("frontend/enums/nationality.enum", function(){ return i("../enums/nationality.enum.js");});
d("frontend/enums/professional-situation.enum", function(){ return i("../enums/professional-situation.enum.js");});
d("frontend/enums/study-level.enum", function(){ return i("../enums/study-level.enum.js");});
d("frontend/enums/tag-type.enum", function(){ return i("../enums/tag-type.enum.js");});
d("frontend/enums/target-audience.enum", function(){ return i("../enums/target-audience.enum.js");});
d("frontend/enums/type-of-teaching.enum", function(){ return i("../enums/type-of-teaching.enum.js");});
d("frontend/enums/unemployed-length.enum", function(){ return i("../enums/unemployed-length.enum.js");});
d("frontend/flash/object", function(){ return i("../flash/object.js");});
d("frontend/formats", function(){ return i("../formats.js");});
d("frontend/index", function(){ return i("../index.js");});
d("frontend/initializers/app-version", function(){ return i("../initializers/app-version.js");});
d("frontend/initializers/container-debug-adapter", function(){ return i("../initializers/container-debug-adapter.js");});
d("frontend/initializers/ember-data-data-adapter", function(){ return i("../initializers/ember-data-data-adapter.js");});
d("frontend/initializers/ember-data", function(){ return i("../initializers/ember-data.js");});
d("frontend/initializers/ember-simple-auth", function(){ return i("../initializers/ember-simple-auth.js");});
d("frontend/initializers/main", function(){ return i("../initializers/main.js");});
d("frontend/initializers/setup-ember-can", function(){ return i("../initializers/setup-ember-can.js");});
d("frontend/initializers/simple-auth-token", function(){ return i("../initializers/simple-auth-token.js");});
d("frontend/instance-initializers/clear-double-boot", function(){ return i("../instance-initializers/clear-double-boot.js");});
d("frontend/instance-initializers/ember-data", function(){ return i("../instance-initializers/ember-data.js");});
d("frontend/instance-initializers/ember-simple-auth", function(){ return i("../instance-initializers/ember-simple-auth.js");});
d("frontend/instance-initializers/head-browser", function(){ return i("../instance-initializers/head-browser.js");});
d("frontend/instance-initializers/sentry-performance", function(){ return i("../instance-initializers/sentry-performance.js");});
d("frontend/interfaces/address", function(){ return i("../interfaces/address.js");});
d("frontend/interfaces/address", function(){ return i("../interfaces/address.ts");});
d("frontend/interfaces/applicant/company", function(){ return i("../interfaces/applicant/company.ts");});
d("frontend/interfaces/applicant/teacher", function(){ return i("../interfaces/applicant/teacher.ts");});
d("frontend/interfaces/applicant/unemployed", function(){ return i("../interfaces/applicant/unemployed.ts");});
d("frontend/interfaces/duration", function(){ return i("../interfaces/duration.js");});
d("frontend/interfaces/og-metadata", function(){ return i("../interfaces/og-metadata.js");});
d("frontend/locations/none", function(){ return i("../locations/none.js");});
d("frontend/models/action", function(){ return i("../models/action.js");});
d("frontend/models/action", function(){ return i("../models/action.ts");});
d("frontend/models/application", function(){ return i("../models/application.ts");});
d("frontend/models/base-apply-user", function(){ return i("../models/base-apply-user.ts");});
d("frontend/models/cover", function(){ return i("../models/cover.js");});
d("frontend/models/cover", function(){ return i("../models/cover.ts");});
d("frontend/models/description", function(){ return i("../models/description.js");});
d("frontend/models/description", function(){ return i("../models/description.ts");});
d("frontend/models/document", function(){ return i("../models/document.js");});
d("frontend/models/document", function(){ return i("../models/document.ts");});
d("frontend/models/family", function(){ return i("../models/family.js");});
d("frontend/models/family", function(){ return i("../models/family.ts");});
d("frontend/models/formator-image", function(){ return i("../models/formator-image.js");});
d("frontend/models/formator-image", function(){ return i("../models/formator-image.ts");});
d("frontend/models/formator", function(){ return i("../models/formator.ts");});
d("frontend/models/module", function(){ return i("../models/module.js");});
d("frontend/models/module", function(){ return i("../models/module.ts");});
d("frontend/models/og-image", function(){ return i("../models/og-image.js");});
d("frontend/models/product", function(){ return i("../models/product.js");});
d("frontend/models/product", function(){ return i("../models/product.ts");});
d("frontend/models/tag", function(){ return i("../models/tag.ts");});
d("frontend/models/testimony-image", function(){ return i("../models/testimony-image.ts");});
d("frontend/models/user", function(){ return i("../models/user.js");});
d("frontend/models/user", function(){ return i("../models/user.ts");});
d("frontend/router", function(){ return i("../router.js");});
d("frontend/serializers/-default", function(){ return i("../serializers/-default.js");});
d("frontend/serializers/-json-api", function(){ return i("../serializers/-json-api.js");});
d("frontend/serializers/-rest", function(){ return i("../serializers/-rest.js");});
d("frontend/serializers/application", function(){ return i("../serializers/application.ts");});
d("frontend/services/-ensure-registered", function(){ return i("../services/-ensure-registered.js");});
d("frontend/services/abilities", function(){ return i("../services/abilities.js");});
d("frontend/services/base-document", function(){ return i("../services/base-document.ts");});
d("frontend/services/can", function(){ return i("../services/can.js");});
d("frontend/services/changesets/apply", function(){ return i("../services/changesets/apply.ts");});
d("frontend/services/changesets/changeset-service", function(){ return i("../services/changesets/changeset-service.js");});
d("frontend/services/changesets/contact-form", function(){ return i("../services/changesets/contact-form.ts");});
d("frontend/services/changesets/contact", function(){ return i("../services/changesets/contact.ts");});
d("frontend/services/changesets/intra-form", function(){ return i("../services/changesets/intra-form.ts");});
d("frontend/services/changesets/newsletter", function(){ return i("../services/changesets/newsletter.ts");});
d("frontend/services/changesets/profile", function(){ return i("../services/changesets/profile.ts");});
d("frontend/services/changesets/recontact-form", function(){ return i("../services/changesets/recontact-form.ts");});
d("frontend/services/changesets/register", function(){ return i("../services/changesets/register.ts");});
d("frontend/services/cookies", function(){ return i("../services/cookies.js");});
d("frontend/services/current-changeset", function(){ return i("../services/current-changeset.js");});
d("frontend/services/current-transition", function(){ return i("../services/current-transition.js");});
d("frontend/services/current-user", function(){ return i("../services/current-user.ts");});
d("frontend/services/dialog-layer", function(){ return i("../services/dialog-layer.js");});
d("frontend/services/download-file", function(){ return i("../services/download-file.js");});
d("frontend/services/error-handler", function(){ return i("../services/error-handler.js");});
d("frontend/services/extended-store", function(){ return i("../services/extended-store.js");});
d("frontend/services/fastboot", function(){ return i("../services/fastboot.js");});
d("frontend/services/favorite-adapters/backend", function(){ return i("../services/favorite-adapters/backend.ts");});
d("frontend/services/favorite-adapters/local-storage", function(){ return i("../services/favorite-adapters/local-storage.ts");});
d("frontend/services/favorite", function(){ return i("../services/favorite.ts");});
d("frontend/services/fetch", function(){ return i("../services/fetch.js");});
d("frontend/services/flash-messages", function(){ return i("../services/flash-messages.js");});
d("frontend/services/head-data", function(){ return i("../services/head-data.js");});
d("frontend/services/head-data", function(){ return i("../services/head-data.ts");});
d("frontend/services/intl", function(){ return i("../services/intl.js");});
d("frontend/services/loading", function(){ return i("../services/loading.js");});
d("frontend/services/page-title-list", function(){ return i("../services/page-title-list.js");});
d("frontend/services/page-title", function(){ return i("../services/page-title.js");});
d("frontend/services/panel-actions", function(){ return i("../services/panel-actions.js");});
d("frontend/services/session", function(){ return i("../services/session.js");});
d("frontend/services/session", function(){ return i("../services/session.ts");});
d("frontend/services/store-document", function(){ return i("../services/store-document.js");});
d("frontend/services/store", function(){ return i("../services/store.js");});
d("frontend/session-stores/application", function(){ return i("../session-stores/application.js");});
d("frontend/tailwind/tailwind.config", function(){ return i("../tailwind/tailwind.config.js");});
d("frontend/test-access/access-token", function(){ return i("../test-access/access-token.js");});
d("frontend/transforms/boolean", function(){ return i("../transforms/boolean.js");});
d("frontend/transforms/date", function(){ return i("../transforms/date.js");});
d("frontend/transforms/number", function(){ return i("../transforms/number.js");});
d("frontend/transforms/string", function(){ return i("../transforms/string.js");});
d("frontend/types/typed-changeset", function(){ return i("../types/typed-changeset.js");});
d("frontend/utils/build-breadcrumb", function(){ return i("../utils/build-breadcrumb.ts");});
d("frontend/utils/do-if-changeset", function(){ return i("../utils/do-if-changeset.js");});
d("frontend/utils/file-to-form-data", function(){ return i("../utils/file-to-form-data.js");});
d("frontend/utils/generic-diff", function(){ return i("../utils/generic-diff.js");});
d("frontend/utils/get-parent-families", function(){ return i("../utils/get-parent-families.ts");});
d("frontend/utils/get-product-id-from-model", function(){ return i("../utils/get-product-id-from-model.ts");});
d("frontend/utils/intl/missing-message", function(){ return i("../utils/intl/missing-message.js");});
d("frontend/utils/intl/missing-message", function(){ return i("../utils/intl/missing-message.ts");});
d("frontend/utils/is-changeset-array", function(){ return i("../utils/is-changeset-array.js");});
d("frontend/utils/is-changeset", function(){ return i("../utils/is-changeset.js");});
d("frontend/utils/nested-changeset/data", function(){ return i("../utils/nested-changeset/data.js");});
d("frontend/utils/nested-changeset/errors", function(){ return i("../utils/nested-changeset/errors.js");});
d("frontend/utils/nested-changeset/execute", function(){ return i("../utils/nested-changeset/execute.js");});
d("frontend/utils/nested-changeset/is-dirty", function(){ return i("../utils/nested-changeset/is-dirty.js");});
d("frontend/utils/nested-changeset/is-valid", function(){ return i("../utils/nested-changeset/is-valid.js");});
d("frontend/utils/nested-changeset/validate", function(){ return i("../utils/nested-changeset/validate.js");});
d("frontend/utils/reactive-changeset", function(){ return i("../utils/reactive-changeset.js");});
d("frontend/utils/sanitize-string", function(){ return i("../utils/sanitize-string.js");});
d("frontend/utils/to", function(){ return i("../utils/to.js");});
d("frontend/utils/truncate", function(){ return i("../utils/truncate.ts");});
d("frontend/utils/validate-and-map", function(){ return i("../utils/validate-and-map.js");});
d("frontend/utils/window-history-back", function(){ return i("../utils/window-history-back.js");});
d("frontend/validations/applicant", function(){ return i("../validations/applicant.ts");});
d("frontend/validations/apply", function(){ return i("../validations/apply.ts");});
d("frontend/validations/base-phone-email", function(){ return i("../validations/base-phone-email.ts");});
d("frontend/validations/contact-form", function(){ return i("../validations/contact-form.ts");});
d("frontend/validations/contact", function(){ return i("../validations/contact.ts");});
d("frontend/validations/forgot-password", function(){ return i("../validations/forgot-password.js");});
d("frontend/validations/intra", function(){ return i("../validations/intra.ts");});
d("frontend/validations/login", function(){ return i("../validations/login.js");});
d("frontend/validations/newsletter", function(){ return i("../validations/newsletter.ts");});
d("frontend/validations/profile", function(){ return i("../validations/profile.ts");});
d("frontend/validations/recontact-form", function(){ return i("../validations/recontact-form.ts");});
d("frontend/validations/register", function(){ return i("../validations/register.ts");});
d("frontend/validations/reset-password", function(){ return i("../validations/reset-password.js");});
d("frontend/validations/utils/email", function(){ return i("../validations/utils/email.ts");});
d("frontend/modifiers/did-insert", function(){ return i("../modifiers/did-insert.js");});
d("frontend/modifiers/did-update", function(){ return i("../modifiers/did-update.js");});
d("frontend/modifiers/focus-trap", function(){ return i("../modifiers/focus-trap.js");});
d("frontend/modifiers/offset-class", function(){ return i("../modifiers/offset-class.ts");});
d("frontend/modifiers/on-click-outside", function(){ return i("../modifiers/on-click-outside.js");});
d("frontend/modifiers/will-destroy", function(){ return i("../modifiers/will-destroy.js");});
d("frontend/templates/application", function(){ return i("../templates/application.hbs");});
d("frontend/application/controller", function(){ return i("../application/controller.ts");});
d("frontend/application/route", function(){ return i("../application/route.ts");});

  if (macroCondition(getGlobalConfig().fastboot?.isRunning)) {
d("frontend/initializers/ajax", function(){ return i("../initializers/ajax.js");});
d("frontend/initializers/error-handler", function(){ return i("../initializers/error-handler.js");});
d("frontend/instance-initializers/setup-fetch", function(){ return i("../instance-initializers/setup-fetch.js");});
  }


w._embroiderRouteBundles_ = [
  {
    names: ["404"],
    load: function() {
      return import("./_route_/404.js");
    }
  },
  {
    names: ["catalog.action.apply.index"],
    load: function() {
      return import("./_route_/catalog.action.apply.index.js");
    }
  },
  {
    names: ["catalog.action.apply.thank-you"],
    load: function() {
      return import("./_route_/catalog.action.apply.thank-you.js");
    }
  },
  {
    names: ["catalog.action.apply"],
    load: function() {
      return import("./_route_/catalog.action.apply.js");
    }
  },
  {
    names: ["catalog.action.index"],
    load: function() {
      return import("./_route_/catalog.action.index.js");
    }
  },
  {
    names: ["catalog.action"],
    load: function() {
      return import("./_route_/catalog.action.js");
    }
  },
  {
    names: ["catalog.index"],
    load: function() {
      return import("./_route_/catalog.index.js");
    }
  },
  {
    names: ["catalog.product"],
    load: function() {
      return import("./_route_/catalog.product.js");
    }
  },
  {
    names: ["catalog"],
    load: function() {
      return import("./_route_/catalog.js");
    }
  },
  {
    names: ["dashboard.applies"],
    load: function() {
      return import("./_route_/dashboard.applies.js");
    }
  },
  {
    names: ["dashboard.favorites"],
    load: function() {
      return import("./_route_/dashboard.favorites.js");
    }
  },
  {
    names: ["dashboard.index"],
    load: function() {
      return import("./_route_/dashboard.index.js");
    }
  },
  {
    names: ["dashboard.profile"],
    load: function() {
      return import("./_route_/dashboard.profile.js");
    }
  },
  {
    names: ["dashboard"],
    load: function() {
      return import("./_route_/dashboard.js");
    }
  },
  {
    names: ["forgot-password"],
    load: function() {
      return import("./_route_/forgot-password.js");
    }
  },
  {
    names: ["formations.index"],
    load: function() {
      return import("./_route_/formations.index.js");
    }
  },
  {
    names: ["formations"],
    load: function() {
      return import("./_route_/formations.js");
    }
  },
  {
    names: ["index"],
    load: function() {
      return import("./_route_/index.js");
    }
  },
  {
    names: ["login"],
    load: function() {
      return import("./_route_/login.js");
    }
  },
  {
    names: ["logout"],
    load: function() {
      return import("./_route_/logout.js");
    }
  },
  {
    names: ["register"],
    load: function() {
      return import("./_route_/register.js");
    }
  },
  {
    names: ["reset-password"],
    load: function() {
      return import("./_route_/reset-password.js");
    }
  },
  {
    names: ["head"],
    load: function() {
      return import("./_route_/head.js");
    }
  },
]



if (typeof FastBoot === 'undefined') {
  if (!runningTests) {
    require('frontend/app')['default'].create({"name":"frontend","version":"1.0.0"});
  }
}


